(function() {
    'use strict';

    angular.module('settings')
        .controller('FaqCreateController', FaqCreateController);

    FaqCreateController.$inject = ['$state', 'faqDataSrvc', 'notificationSrvc', 'faqMessagesConst', 'faqSectionsConst', 'errorNotificationSrvc'];

    function FaqCreateController($state, faqDataSrvc, notificationSrvc, faqMessagesConst, faqSectionsConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            title_pl: [],
            description_pl: [],
            title_en: [],
            description_en: [],
            title_de: [],
            description_de: [],
            title_cpde: [],
            description_cpde: [],
            title_cpen: [],
            description_cpen: [],
            section: [],
            nonFieldErrors: []
        };

        self.faqData = {
            title_pl: '',
            description_pl: '',
            title_en: '',
            description_en: '',
            title_de: '',
            description_de: '',
            title_cpde: '',
            description_cpde: '',
            title_cpen: '',
            description_cpen: '',
            section: ''
        };

        self.sections = faqSectionsConst;

        self.createFaq = createFaq;
        self.cleanErrors = cleanErrors;

        function createFaq() {
            faqDataSrvc.create(
                self.faqData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", faqMessagesConst.add);
                    $state.go('layout.faq.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
